import clsx from "clsx";
import { memo } from "react";

import { Typography } from "../typography";

import classes from "./styles.module.scss";

import type { IContentDivider } from "./types";

export const ContentDivider = memo(function ContentDivider(
  props: IContentDivider,
) {
  const { variant = "line", type = "horizontal", className, text } = props;

  switch (variant) {
    case "line":
      return <div data-dir={type} className={clsx(className, classes.line)} />;
    case "lineSpacing":
      return (
        <div className={clsx(className, classes.lineSpacing)}>
          <div className={clsx(classes.line)} />
        </div>
      );
    case "text":
      return (
        <div className={clsx(className, classes.text)}>
          <Typography
            fontType={"subheading-x-small"}
            themeColor={"text-soft-400"}
          >
            {text}
          </Typography>
        </div>
      );
    case "solidText":
      return (
        <div className={clsx(className, classes.solidText)}>
          <Typography
            fontType={"subheading-x-small"}
            themeColor={"text-soft-400"}
          >
            {text}
          </Typography>
        </div>
      );
    case "textDivider":
      return (
        <div className={clsx(className, classes.textDivider)}>
          <div
            className={clsx(classes.line, classes.grow)}
            data-dir={"horizontal"}
          />
          <Typography
            fontType={"subheading-x-small"}
            themeColor={"text-soft-400"}
          >
            {text}
          </Typography>
          <div
            className={clsx(classes.line, classes.grow)}
            data-dir={"horizontal"}
          />
        </div>
      );
  }
});
